export default {
  "description": "_description_1ikyp_1",
  "wrapper": "_wrapper_1ikyp_5",
  "uploadInfo": "_uploadInfo_1ikyp_19",
  "galleryControl": "_galleryControl_1ikyp_27",
  "header": "_header_1ikyp_45",
  "name": "_name_1ikyp_59"
};import "ni:sha-256;2j4sZFwGX7ZQTaOkwyVbI8zGU8BQAtG-Ogzg672qP9g";